import { autoinject } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { validateEmail, validatePostalCode, validatePhoneNumber } from 'app/shared/lib/validation/validation-utilities';
import { IPopup } from 'app/shared/elements/popup-base';
import { FormSuccessCustomEvent } from 'app/shared/elements/forms/ess-form';
import { validate } from 'app/shared/elements/ess-rule';
import { guid } from 'app/shared/lib/guid';

interface ValidateUtility {
    $display: string,
    validateFn: Function,
    description: string,
    label: string
}

@autoinject()
export class DemoEssRulePage extends ComponentBase {

    protected validateOptions: Array<ValidateUtility> = [
        { $display: "validateEmail", validateFn: validateEmail, description: "Value must be a valid Email Address.", label: "Email" },
        { $display: "validatePostalCode", validateFn: validatePostalCode, description: "Value must be a valid Postal Code.", label: "Postal Code" },
        { $display: "validatePhoneNumber", validateFn: validatePhoneNumber, description: "Value must be a valid Phone Number.", label: "Phone Number" }
    ];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////
    protected validateEmail = validateEmail;

    ////****************** Example 2 ********************************************////
    protected ex2Validator: ValidateUtility | null = this.validateOptions[0];
    protected ex2Text: string | null = null;


    ////****************** Example 3 ********************************************////
    protected validate = validate;

    protected $saveStuffModal!: IPopup;
    protected $form!: IForm;
    protected $stuffForm!: Element;

    ////****************** Example 3 Events ***************************************************////
    protected formSuccess({ detail }: FormSuccessCustomEvent) {
        this.$saveStuffModal.close();

        if(detail.form.reset) detail.form.reset();
    }

    ////****************** Example 3 Functions ************************************************////
    protected saveStuff(): void {
        this.$saveStuffModal.open();
    }

    protected saveStuffClose(): void {
        if(this.$form.reset) this.$form.reset();
        this.$saveStuffModal.close();
    }

}
